import { Accordion, Box } from '@chakra-ui/react';

import React, { useMemo, useState, useEffect } from 'react';
import FacetItem from './FacetItem';
import { isObjectEmpty } from 'helpers/general';
import * as styles from './Facet.module.css';
import { isMadPawsStore } from '../../../common/util';

const facetMappping = {
  'product_categories.name': {
    display: 'Category',
    order: 1
  },
  brand_name: {
    display: 'Brands',
    order: 2
  },
  pets: {
    display: 'Pet',
    order: 3
  },
  healthCondition: {
    display: 'Health condition',
    order: 4
  },
  lifeStage: {
    display: 'Life stage',
    order: 4
  },
  foodType: {
    display: 'Food type',
    order: 4
  }
};
const Facet = ({ facets, selectHandler, activeFilters, forceOpen = false, exclude }) => {
  const [displayedFacets, setDisplayedFacets] = useState([]);
  const facetArray = useMemo(() => {
    if (!facets) return [];

    let array = [];
    for (let type in facets) {
      let innerObject = facets[type];
      if (!innerObject) continue; // Ensure innerObject is valid

      let children = [];
      for (let name in innerObject) {
        let excludeValue = false;

        if (exclude && name === exclude) {
          excludeValue = true;
        }

        let value = innerObject[name];

        if (excludeValue) continue;

        children.push({ name, value });
      }

      let display = facetMappping[type] ? facetMappping[type].display : 'Unknown';
      let order = facetMappping[type] ? facetMappping[type].order : Infinity;

      array.push({ type, display, order, children });
    }

    array.sort((a, b) => a.order - b.order);

    return array;
  }, [facets, exclude]);

  useEffect(() => {
    if (!isObjectEmpty(facets)) {
      setDisplayedFacets(facetArray);
    }
  }, [facetArray, facets]);

  return (
    <Box flexShrink={0} className={styles.root} w={'full'} minH={'60vh'} height={'full'}>
      <Accordion
        allowMultiple
        defaultIndex={forceOpen ? facetArray?.map((_, i) => i) : [0, 1]}
        sx={{
          '& > div:not(:last-child)': {
            borderBottom: `1px solid ${isMadPawsStore() ? '#EAEAEA' : '#D5DFE9'}`
          }
        }}
      >
        {displayedFacets?.map((facet, i) => (
          <FacetItem
            key={i}
            index={i}
            facet={facet}
            selectHandler={selectHandler}
            activeFilters={activeFilters}
          />
        ))}

        <FacetItem
          hideValue
          facet={{
            type: 'calculated_price',
            display: 'Price',
            children: [
              { value: '0 TO 50', name: '$0 - $50' },
              { value: '50 TO 100', name: '$50 - $100' },
              { value: '100 TO 150', name: '$100 - $150' },
              { value: '150 TO 200', name: '$150 - $200' },
              { value: '200 TO 500', name: '$200 - $500' },
              { value: '501 TO 9999', name: 'Over $500' }
            ]
          }}
          selectHandler={selectHandler}
          activeFilters={activeFilters}
        />
      </Accordion>
    </Box>
  );
};

export default Facet;
